// ----------------------------------------------------------------------------
// Template: Gift Card
// ----------------------------------------------------------------------------
// A file that contains scripts highly couple code to the Gift Card template.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';

// Styles
import './_gift_card.scss';

// -------------------------------------
// Variables
// -------------------------------------

var config = {
  qrCode: '#QrCode',
  printButton: '#PrintGiftCard',
  giftCardCode: '.giftcard__code'
};

// -------------------------------------
// Helper Functions
// -------------------------------------
function selectText(evt) {
  var text = document.getElementById(evt.data.element);
  var range = '';
  if (document.body.createTextRange) {
    range = document.body.createTextRange();
    range.moveToElementText(text);
    range.select();
  } else if (window.getSelection) {
    var selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}

// new QRCode($qrCode[0], {
//   text: $qrCode.attr('data-identifier'),
//   width: 120,
//   height: 120,
// });

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  var printButton = document.querySelector(config.printButton);
  printButton === null || printButton === void 0 || printButton.addEventListener('click', () => {
    window.print();
  });

  // Auto-select gift card code on click, based on ID passed to the function
  document.querySelectorAll(config.giftCardCode).forEach(element => {
    element.addEventListener('click', () => {
      selectText({
        data: {
          element: 'GiftCardDigits'
        }
      });
    });
  });
});